$(document).ready(function() {
  $('.about-meet-out-button').click(function(e) {
    e.preventDefault(); // Prevent the default behavior of the link (if it's a link)
    // Find the associated .about-meet-popup
    var $popup = $(this).closest('.about-meet-out-team-blocks').find('.about-meet-popup');
    $('.about-meet-popup').not($popup).fadeOut('slow');
    $popup.fadeIn('slow');
  });

  // Add a click event listener to the .about-meet-team-close
  $('.about-meet-team-close').click(function(e) {
    e.preventDefault(); // Prevent the default behavior of the link (if it's a link)
    $(this).closest('.about-meet-popup').fadeOut('slow');
  });

  // Add a click event listener to the .about-meet-popup-tab-bio
  $('.about-meet-popup-tab-bio').click(function() {
    var tabName = $(this).data('bio'); // Get the data-bio attribute value
    var $block = $(this).closest('.about-meet-popup');
    $block.find('.about-meet-popup-tab-wise-content > div').hide();
    var $content = $block.find('.about-meet-bio-content[data-tab-content="' + tabName + '"]');
    $content.show();
    $block.find('.about-meet-popup-tab-bio').removeClass('about-active-tab');
    $(this).addClass('about-active-tab');    
    $block.find('.about-meet-bio-content').removeClass('about-active-content');
    $content.addClass('about-active-content');
  });
  
});
